import { authHeader, config, options } from "../../components/common/helpers";
import { polyfill } from "es6-promise";
import { fetch } from "whatwg-fetch";

polyfill();

export const bootstrapService = {
  measurementcategory,
  measurementtype,
  measurementmagnitude,
};
function measurementtype() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const serviceurl = options(config.apiUrl + `/measurementtype`);

  return fetch(serviceurl, requestOptions)
    .then(handleResponse, handleError)
    .then((response) => {
      // login successful if there's a token in the response
      if (response.measurementType) {
        localStorage.setItem(
          "measurementType",
          JSON.stringify(response.measurementType)
        );
      }
      return response.measurementType;
    });
}

function measurementcategory() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const serviceurl = options(config.apiUrl + `/measurementcategory`);

  return fetch(serviceurl, requestOptions)
    .then(handleResponse, handleError)
    .then((response) => {
      // login successful if there's a token in the response
      if (response.measurementCategory) {
        localStorage.setItem(
          "measurementCategory",
          JSON.stringify(response.measurementCategory)
        );
      }
      return response.measurementCategory;
    });
}

function measurementmagnitude() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const serviceurl = options(config.apiUrl + `/measurementmagnitude`);

  return fetch(serviceurl, requestOptions)
    .then(handleResponse, handleError)
    .then((response) => {
      // login successful if there's a token in the response
      if (response.measurementMagnitude) {
        localStorage.setItem(
          "measurementMagnitude",
          JSON.stringify(response.measurementMagnitude)
        );
      }
      return response.measurementMagnitude;
    });
}

export function handleResponse(response) {
  return new Promise((resolve, reject) => {
    if (response.ok) {
      // return json if it was returned in the response
      var contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") > -1) {
        response.json().then((json) => resolve(json));
      } else {
        resolve();
      }
    } else {
      // return error message from response body
      response.text().then((text) => reject(text));
    }
  });
}

export function handleError(error) {
  console.log("Received errorr api data : " + error);
  return Promise.reject(error && error.message);
}
